import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CucurachaAdminService } from '../service/cucuracha.service';


@Component({
  selector: 'app-mainview',
  templateUrl: './mainview.component.html',
  styleUrls: ['./mainview.component.css']
})
export class MainviewComponent implements OnInit {
 
show:any
userSession:any;
userDetails:any;
idleInterval:any
idleTime: number = 0;
userSessionData:any;
myurl: string;
deviceInfo:any;
isMobile: boolean= false;
  constructor(private router: Router,private cs:CucurachaAdminService) { 
    this.myurl = this.cs.endpoint;
 
  }
  logOut(){
    var now = Date.now();
    this.cs.logoutSysLog(localStorage.getItem('token')).subscribe((data) => {
    })

    localStorage.removeItem('token')
    localStorage.removeItem('user')

    this.router.navigate(['']);
   
  }
 
  reloadPage() {
    console.log(new Date(performance.timing.domLoading).getTime())

    var currentDocumentTimestamp = new Date(performance.timing.domLoading).getTime();
    // Current Time //
    var now = Date.now();
    // Total Process Lenght as Minutes //
    var tenSec = 3 * 1000;
    // End Time of Process //
    var plusTenSec = currentDocumentTimestamp + tenSec;
    console.log(currentDocumentTimestamp)
    console.log(now)

    if (now > plusTenSec) {
      location.reload();
    }
  }
 
  ngOnInit(): void {
 
    this.reloadPage();
    this.userSession = (JSON.parse(localStorage.getItem('token')))
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))
    console.log(this.userSessionData)
    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
      console.log(data)
    })
  
  }
  
}
